import { Component, input } from '@angular/core';

@Component({
  selector: 'app-validation-error',
  standalone: true,
  imports: [],
  template: `
  @for (error of errors(); track $index) {
    <div class="error-text margin-top-1">{{error}}</div>
  }
  `,
  styles: `
    .error-text {
      color: red;
      font-size: 14px;
    }
  `
})
export class ValidationErrorComponent {
  // simple component to show error message which will come as an array input
  errors = input.required<string[]>();



}
